module.exports = __webpack_public_path__ + "img/no.9160f377.svg";